import moment from 'moment';

export default function getTimeDelta(startTime: string | null, endTime: string | null) {
    const startTimeSec = moment(startTime).valueOf() / 1000;
    const endTimeSec = moment(endTime).valueOf() / 1000;

    return endTimeSec - startTimeSec;
}
